import React from 'react';
import { motion } from 'framer-motion';
export function PositioningStrip() {
  return <section className="py-20 sm:py-28 lg:py-36 bg-white border-t border-gray-100" data-id="element-174">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-175">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-2xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-[1.15] tracking-tight" data-id="element-176">
          La mejor app de obra
          <span className="block text-blue-600 mt-2 sm:mt-3" data-id="element-177">
            es la que nadie tiene que aprender.
          </span>
        </motion.p>
      </div>
    </section>;
}